import React from "react";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  useMediaQuery,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import theme from "../../theme";

function ProductSearchBar({
  value,
  onChange,
  placeholder = "Search products...",
  align = "center",
}) {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        width: isMobile ? "95%" : "972px",
        display: "flex",
        justifyContent: align === "left" ? "flex-start" : "center",
        alignItems: "center",
        marginTop: "12px",
      }}
    >
      <TextField
        fullWidth
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon sx={{ color: "#6F6F6F" }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="Clear search"
                onClick={() => onChange({ target: { value: "" } })}
                edge="end"
                size="small"
                sx={{ color: "#6F6F6F" }}
              >
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          maxWidth: isMobile ? "100%" : "520px",
          backgroundColor: "#FFFFFF",
          borderRadius: "14px",
          boxShadow: "0 14px 34px rgba(17, 17, 17, 0.12)",
          "& .MuiOutlinedInput-root": {
            borderRadius: "14px",
            boxShadow: "0 8px 20px rgba(17, 17, 17, 0.08)",
            "& fieldset": {
              borderColor: "#CFC7BE",
              borderWidth: "1.5px",
            },
            "&:hover fieldset": {
              borderColor: "#BFA15D",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#000000",
              borderWidth: "2px",
            },
          },
          "& .MuiInputBase-input": {
            fontSize: isMobile ? "14px" : "16px",
            fontWeight: 500,
            paddingY: isMobile ? "12px" : "14px",
          },
        }}
      />
    </Box>
  );
}

export default ProductSearchBar;
